import BlankBill from '../blankbill';
import { connect } from "react-redux";
import React, { Component } from 'react';
import { MOD_BILL } from "../../../../permissions";
import TableBill from '../../tableProvider/table-bill';
import { getNumberApprovals } from '../../../utils/functions';
import { getModules } from '../../../../Redux/reducer/clients';
import { getBills, getTotalElements } from '../../../../Redux/reducer/bills';
import { getBillsList, clearBillsList } from '../../../../Redux/actions/billActions';
import { getAuthenticatedClientModules } from "../../../../Redux/actions/clientActions";

export class DraftList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      sizePerPage: this.props.pageSize,
      filters: [{ property: 'status', operator: 'eq', value: 'DRAFT' }],
      componentReady: false
    }
  }

  componentDidMount() {
    if(this.props.pageSize !== 10){
      this.props.handlePageSizeSelection(10);
      return;
    }

    this.props.handleBillSelection(this.props.defaultBillSelection);

    if(this.props.modules.length <= 0) {
      this.props.getClientModules();
    }
    return this.loadBills();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.pageSize !== this.props.pageSize) {
      this.props.setModal(true)
      this.setState({ sizePerPage: this.props.pageSize, page: 0 }, () => {
        this.loadBills()
      });
    }

    var customFilters = this.getFilters();
    if (JSON.stringify(customFilters) !== JSON.stringify(this.state.filters)) {
      this.setState({ filters: customFilters});
      this.loadBills();
    }
  }

  componentWillUnmount() {
    this.props.handlePageSizeSelection(10);
    this.props.clearBillsList();
    this.props.setModal(true);
  }

  loadBills() {
    var customFilters = this.getFilters();
    return this.props.getBillsList(this.state.page, this.state.sizePerPage, customFilters).then(() => {
      this.props.setModal(false);
      this.setState({ componentReady: true, filters: customFilters });
    });
  }

  getFilters() {
    var defaultFilter = [{ property: 'status', operator: 'eq', value: 'DRAFT' }]
    var customFilters = [...this.props.filters, ...defaultFilter];
    return customFilters;
  }

  getBillsHandler = (page, sizePerPage, paramfilters, sortFilter) => {
    this.props.setModal(true);
    return this.props.getBillsList(page, sizePerPage, paramfilters, sortFilter).then(() => {
      this.setState({ page: page, sizePerPage: sizePerPage })
      this.props.setModal(false);
    });
  };

  render() {
    const { componentReady, page, sizePerPage, filters } = this.state;
    const { bills, totalElements, updateCreditLine, billSelection, handleBillSelection } = this.props;

    const approvals = getNumberApprovals(this.props.modules, MOD_BILL);

    return componentReady ?
      bills.length > 0 ? <TableBill
        data={bills}
        page={page}
        getBillsList={this.getBillsHandler}
        totalSize={totalElements}
        sizePerPage={sizePerPage}
        filters={filters}
        updateCreditLine={updateCreditLine}
        approvedTo={`PENDING`}
        mode='draft'
        needToken={approvals <= 0}
        updateOnSubmit={true}
        defaultBillSelection={this.props.defaultBillSelection}
        billSelection={billSelection}
        handleBillSelection={handleBillSelection}
        excludedStatus={this.props.excludedStatus}
      /> : <BlankBill />
      : null;
  }

}

export const mapStateToProps = state => {
  return {
    bills: getBills(state),
    totalElements: getTotalElements(state),
    modules: getModules(state),
  }
}

export const mapDispatch = dispatch => {
  return {
    getBillsList: (page, size, filters, sort) => dispatch(getBillsList(page, size, filters, sort)),
    clearBillsList: (payload) => dispatch(clearBillsList(payload)),
    getClientModules: () => dispatch(getAuthenticatedClientModules()),
  };
};

export default connect(mapStateToProps, mapDispatch)(DraftList);
